// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a2352352","455":"73bbc3ec","885":"e012ed3f"}[chunkId] + ".chunk.js";
};